export default __webpack_public_path__ + "static/media/pagtrust.alt.75228e95.png";